import React from 'react';
import Drawer from '../../shared/ui/Drawer.js';
import FinanceUploadFlow from '../finance/FinanceUploadFlow.js';

interface DailyEntryDSWUploadDrawerProps {
  open: boolean;
  onClose: () => void;
  onImported?: () => void;
}

/**
 * Daily Entry's dedicated upload surface for daily DSW.
 * Only `daily_service_worksheet` is accepted; weekly DSW and GF reports are
 * rejected with a pointer back to Finance to keep workflow ownership clean.
 */
export default function DailyEntryDSWUploadDrawer({ open, onClose, onImported }: DailyEntryDSWUploadDrawerProps) {
  return (
    <Drawer open={open} onClose={onClose} title="Upload daily DSW" width={540}>
      <FinanceUploadFlow
        acceptedTypes={['daily_service_worksheet']}
        rejectMessage="This isn't a Daily Service Worksheet. Weekly DSW and GF reports belong under Finance → Upload report, not Daily Entry."
        onImported={onImported}
      />
    </Drawer>
  );
}
